import { Route, Switch } from 'react-router';
import { RouterPaths } from "../../app/appConstants";
import WelcomePageNoName from "../Welcome/WelcomePageNoName/WelcomePageNoNameLoadable";
import PageNotFound from "../../app/PageNotFound";
import React from "react";
import { Redirect } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { makeSelectAppLoggedIn } from "../../app/appSelectors";
import { connect } from "react-redux";

function PromoRoute(props) {
    const {loggedIn} = props;

    if (loggedIn) {
        return <Redirect to={RouterPaths.main}/>
    }

    return <Switch>
        <Route exact path={`${RouterPaths.promo}/l1`} component={WelcomePageNoName}/>
        <Route path="**" component={PageNotFound}/>
    </Switch>
}

const mapStateToProps = createStructuredSelector({
    loggedIn: makeSelectAppLoggedIn(),
});

export default connect(mapStateToProps)(PromoRoute);
